import { PortalBaseViewController } from '@/views/portal/PortalBaseViewController';
import { TTAPI } from '@/services/TimeTrexClientAPI';
import { PortalJobVacancyDetailController } from '@/views/portal/hr/recruitment/PortalJobVacancyDetailController';
import { IndexViewController} from '@/portal/recruitment/IndexController';
import { RecruitmentPortalNavigation } from '@/portal/recruitment/RecruitmentPortalNavigation';

export class PortalJobVacancyDetailViewController extends PortalBaseViewController {
	constructor( options = {} ) {
		_.defaults( options, {
			el: '.job-vacancy-detail-view',
			api: null,

			// _required_files: ['PortalJobVacancyDetailController']
		} );

		super( options );
	}

	init() {
		this.script_name = 'JobVacancyDetailView';
		this.api = TTAPI.APIJobVacancyPortal;
		this.job_detail_panel = this.$( '.search-result' );
		this.job_detail_panel.empty();
		this.render();
	}

	render() {
		var $this = this;
		ProgressBar.showOverlay();
		this.search();
	}

	search() {
		var $this = this;
		var filter = {};
		filter.filter_data = {};
		if ( LocalCacheData.edit_id_for_next_open_view ) {
			this.view_id = LocalCacheData.edit_id_for_next_open_view;
			filter.filter_data.id = [this.view_id];
			ProgressBar.showOverlay();
			this.api.getJobVacancy( filter, {
				onResult: function( result ) {
					var result_data = result.getResult();
					if ( !result_data ) {
						result_data = [];
					}
					result_data = result_data[0];
					if ( result_data && typeof result_data === 'object' ) {
						var detail_model = new Backbone.Model( result_data );
						var portal_job_vacancy_detail = new PortalJobVacancyDetailController( {
							model: detail_model,
							el: $this.$el
						} );
						IndexViewController.instance.router.headerView.jobVacancyDetailController = portal_job_vacancy_detail;
					} else {
						//Record does not exist, redirect to main vacancy page.
						RecruitmentPortalNavigation.goToPortalView( 'PortalJobVacancy', {}, { replace: true, remove_args: [ 'id' ] } );
					}
				}
			} );
			LocalCacheData.edit_id_for_next_open_view = null;
		}
	}

	goPortalLogin() {
		var url = RecruitmentPortalNavigation.getPortalViewURL( 'PortalJobVacancy', {}, { remove_args: [ 'id' ] } );

		if ( window.location.href === url ) {
			IndexViewController.instance.router.reloadView( 'PortalJobVacancy' );
		} else {
			RecruitmentPortalNavigation.goToPortalView( 'PortalJobVacancy', {}, { remove_args: [ 'id' ] } );
		}
	}
}

PortalJobVacancyDetailViewController.html_template = `
<div class="view job-vacancy-detail-view"></div>`;
